import { Action } from 'redux';

import { isSelectionStartAction, isSelectionStopAction } from '../../actions/ContentExplorerSelectionActions';

export function selectionBusyReducer(
  previousState: boolean = false,
  action: Action = null
): boolean {
  if (isSelectionStartAction(action)) {
    return true;
  } else if (isSelectionStopAction(action)) {
    return false;
  }

  return previousState;
}
